<template>
	<div>
		<div class="row">
			<div class="col-md-6">
				<multiselect
					v-model="requiredItems"
					:options="allItems"
					:multiple="true"
					:close-on-select="false"
					group-values="options"
					group-label="group"
					track-by="id"
					label="name"
					placeholder="Select Item(s)"
				>
					<template slot="tag" slot-scope="props">
						<span class="multiselect__tag" :title="props.option.name">
							<small v-if="props.option.venueName" class="multiselect__tag-small">{{ props.option.venueName }}</small>
							<p class="multiselect__tag-text">{{ props.option.name }}</p>
							<i aria-hidden="true" tabindex="1" @click="props.remove(props.option)" class="multiselect__tag-icon"></i>
						</span>
					</template>
				</multiselect>

			</div>
			<div class="col-md-6">
				<multiselect
					v-model="requiredPromos"
					:options="promos"
					multiple
					:close-on-select="false"
					track-by="id"
					label="name"
					placeholder="Select Promo(s)"
				>
					<template slot="tag" slot-scope="props">
						<span class="multiselect__tag" :title="props.option.name">
							<span>{{ props.option.name }}</span>
							<i aria-hidden="true" tabindex="1" @click="props.remove(props.option)" class="multiselect__tag-icon"></i>
						</span>
					</template>
				</multiselect>
			</div>
		</div>
		<div class="row" style="margin-top:5px;">
			<div class="col-md-12">
				<textarea
					class="promoRequiredMessage form-control"
					placeholder="Message to customer..."
					v-model="rule.settings.message"
				></textarea>
			</div>
		</div>
	</div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

export default {
	props: {
		allpackages: Array,
		alldeals: Array,
		allproducts: Array,
		rule: Object,
		promos: Array,
	},
	data() {
		return {
			filteredPromos: this.promos,
			filteredEverything: [],
			localAllpackages: cloneDeep(this.allpackages),
			localAlldeals: cloneDeep(this.alldeals),
			localAllproducts: cloneDeep(this.allproducts),
		};
	},
	computed: {
		packagesList() {
			return this.localAllpackages.map((o) => {
				o.settings_attr = 'package_ids';
				o.id = `package-${o.id}`;
				return o;
			});
		},
		dealsList() {
			return this.localAlldeals.map((o) => {
				o.settings_attr = 'deal_ids';
				o.id = `deal-${o.id}`;
				return o;
			});
		},
		productsList() {
			return this.localAllproducts.map((o) => {
				o.settings_attr = 'product_ids';
				o.id = `product-${o.id}`;
				return o;
			});
		},
		allItems() {
			return [
				{
					group: 'Packages',
					settings_attr: 'package_ids',
					options: this.packagesList
				},
				{
					group: 'Deals',
					settings_attr: 'deal_ids',
					options: this.dealsList
				},
				{
					group: 'Products',
					settings_attr: 'product_ids',
					options: this.productsList
				},
			];
		},
		requiredItems: {
			get() {
				let values = [];
				this.allItems.forEach((group) => {
					let filtered = group.options.filter((option) => {
						return this.rule.settings[group.settings_attr].map(Number).indexOf(Number(option.id.split('-')[1])) > -1; 
					});
					if (filtered.length > 0) values = values.concat(filtered);
				});
				return values;
			},
			set(newVal) {
				const groupNames = ['package_ids', 'deal_ids', 'product_ids'];
				if (newVal.length === 0) {
					groupNames.forEach((name) => {
						this.rule.settings[name] = [];
					});
				} else {
					const grouped = _.groupBy(newVal, 'settings_attr');
					groupNames.forEach((name) => {
						if(grouped.hasOwnProperty(name))
							this.rule.settings[name] = grouped[name].map((v) => Number(v.id.split('-')[1]));
						else
							this.rule.settings[name] = [];
					});
				}
			}
		},
		requiredPromos: {
			get() {
				return this.promos.filter((promo) => {
					return this.rule.settings.promo_ids.map(Number).indexOf(promo.id) > -1; 
				});
			},
			set(newVal) {
				this.rule.settings.promo_ids = newVal.map((v) => v.id);
			}
		}
	},
	beforeMount() {
		if(!this.rule.settings.hasOwnProperty("package_ids")) this.$set(this.rule.settings, 'package_ids', []);
		if(!this.rule.settings.hasOwnProperty("deal_ids")) this.$set(this.rule.settings, 'deal_ids', []);
		if(!this.rule.settings.hasOwnProperty("product_ids")) this.$set(this.rule.settings, 'product_ids', []);
		if(!this.rule.settings.hasOwnProperty("promo_ids")) this.$set(this.rule.settings, 'promo_ids', []);
	},
};
</script>